<script>
    import Icon from '@iconify/svelte';
</script>

<div class="absolute top-0 right-0 bottom-0 left-0 grid place-items-center bg-white z-40">
    <Icon icon="svg-spinners:180-ring" class="w-12.5 h-12.5 text-theme-highlight" />
</div>
